import { z } from "zod";

const ALL_FILE_TYPES = [
  "image/webp",
  ".webp",
  "image/png",
  ".png",
  "image/jpeg",
  ".jpeg",
  "image/svg+xml",
] as const;

const FileTypeSchema = z.enum(ALL_FILE_TYPES);

export type FileType = z.infer<typeof FileTypeSchema>;

export const getFileType = (file: File): FileType => {
  const parsed = FileTypeSchema.safeParse(file.type);
  if (!parsed.success) {
    throw new Error(parsed.error.message);
  }
  return parsed.data;
};
